package it.neckar.projects.common

import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

/**
 * The name of a backend service (e.g. `PatternService`, `auth-service`) — as declared by its
 * [ServiceDescriptor].
 *
 * Derived identifiers (the OpenTelemetry service name of a local run, auth-provider names) are built from this value.
 */
@JvmInline
@Serializable
value class ServiceName(val value: String) {
  init {
    require(value.isNotBlank()) { "service name must not be blank" }
  }

  /**
   * [value] in kebab case, `PatternsApi` → `patterns-api`: the OpenTelemetry `service.name` of a run outside a compose stack.
   */
  fun kebabCaseName(): String {
    return value.replace(Regex("([a-z])([A-Z])")) {
      "${it.groupValues[1]}-${it.groupValues[2]}"
    }.lowercase()
  }

  override fun toString(): String = value
}
